class Header {
  constructor(configs) {
    this.configs = configs;
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._toggleTransparent(true);
    this.isAccordionButtonAlreadyClickedOrTouched = false;
    this._setupEventListeners();
  }

  _isIPhoneOrIPad = () => window.navigator.userAgent.match(/iPad/i) || window.navigator.userAgent.match(/iPhone/i);

  _getElements() {
    const container = document.querySelector(this.configs.selectors.header);
    return container ? {
      container,
      body: document.querySelector(this.configs.selectors.body),
      accodtionButton: container.querySelector(this.configs.selectors.accordionButton),
      closeIcons: container.querySelector(this.configs.selectors.closeButton),
      searchMobileButton: container.querySelector(this.configs.selectors.searchMobileButton),
      searchButtons: document.querySelectorAll(this.configs.selectors.searchButton),
      searchWrap: document.querySelector(this.configs.selectors.searchWrap),
      headerOverlay: document.querySelector(this.configs.selectors.headerOverlay)
    } : {};
  }

  _setupEventListeners() {
    const isIPhoneOrIPad = this._isIPhoneOrIPad();

    window.addEventListener('scroll', this._handleContainerScroll.bind(this));
    this.elements.container.addEventListener('mouseover', this._handleAddClassesToBody);
    this.elements.container.addEventListener('mouseout', this._handleRemoveClassesFromBody);
    for (const searchButton of this.elements.searchButtons) {
      searchButton.addEventListener('click', this._handleSearchButtonClick);
    }
    this.elements.closeIcons.addEventListener('click', this._handleAccordionButtonClickOrTouch.bind(this));
    this.elements.headerOverlay.addEventListener('click', this._handleAccordionButtonClickOrTouch.bind(this));
    this.elements.accodtionButton.addEventListener('click', this._handleAccordionButtonClickOrTouch.bind(this));
    this.elements.searchMobileButton?.addEventListener('click', this._handleAccordionButtonClickOrTouch.bind(this));
    if (isIPhoneOrIPad) {
      this.elements.closeIcons.addEventListener('click', this._handleAccordionButtonClickOrTouch.bind(this));
      this.elements.accodtionButton.addEventListener('touchstart', this._handleAccordionButtonClickOrTouch.bind(this));
      this.elements.searchMobileButton?.addEventListener('touchstart', this._handleAccordionButtonClickOrTouch.bind(this));
    }
  }

  _toggleTransparent(isInitial) {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const isPageScrolled = scrollTop > 67;
    const isTransparent = this.configs.isTransparent;
    if (isTransparent && isPageScrolled) {
      this.elements.container.parentNode.classList.remove(this.configs.classes.transparent);
      this.elements.container.parentNode.classList.add(this.configs.classes.pageHasScroll);
    } else if (isTransparent) {
      this.elements.container.parentNode.classList.add(this.configs.classes.transparent);
      this.elements.container.parentNode.classList.remove(this.configs.classes.pageHasScroll);
    } else if (isInitial) {
      if (isPageScrolled && isTransparent) {
        this.elements.container.parentNode.classList.add(this.configs.classes.pageHasScroll);
      }
    }
  }

  _handleContainerScroll() {
    this._toggleTransparent(false);
  }

  _handleAddClassesToBody = () => {
    this.elements.body.classList.add(this.configs.classes.transparentHeader);
  }

  _handleRemoveClassesFromBody = () => {
    this.elements.body.classList.remove(this.configs.classes.transparentHeader);
  }

  _toggleNavigationActive(e) {
    this.elements.body.classList.toggle(this.configs.classes.navigationActive);
    this.elements.container.parentNode.classList.toggle(this.configs.classes.navigationActive);
    if(e.target.closest('.search-mobile')) {
      this.elements.searchWrap.querySelector('input').focus();
    }
  }

  _handleAccordionButtonClickOrTouch(e) {
    const isIPhoneOrIPad = this._isIPhoneOrIPad();
    if (isIPhoneOrIPad) {
      if (this.isAccordionButtonAlreadyClickedOrTouched) return;
      this.isAccordionButtonAlreadyClickedOrTouched = true;
    }
    if (this.elements.body.classList.contains(this.configs.classes.searchActive)) {
      this._toggleSearchActive();
    } else {
      this._toggleNavigationActive(e);
    }
    if (isIPhoneOrIPad) {
      setTimeout(function() {
        this.isAccordionButtonAlreadyClickedOrTouched = false;
      }.bind(this), 500);
    }
  }

  _toggleSearchActive = () => {
    this.elements.body.classList.toggle(this.configs.classes.searchActive);
    this.elements.searchWrap.classList.toggle(this.configs.classes.active);
  }

  _handleSearchButtonClick = () => this._toggleSearchActive();
}
